
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { ObjectUtils } from '@/utils/objects'
import { localStore } from '@/utils/localstore'
import { constant } from '@/utils/constants'

@Options({
  components: {},
  directives: { maska },
})
export default class BaseFormMixin extends Vue {
  parentForm = {
    _id: '',
  }

  initForm: {
    _id: string
    [key: string]: any
  } = { _id: '' }

  testMode = false
  isCancel = false

  get appId() {
    return this.$route.params.app_id as string
  }

  get isNew() {
    return !this.parentForm?._id
  }

  async checkDraftValue() {
    if (Object.keys(this.initForm).length && ObjectUtils.isDifference(this.parentForm, this.initForm)) {
      return await this.notifyUnSaveForm()
    } else {
      return true
    }
  }

  async checkDraftValueOnCampaign() {
    if (Object.keys(this.initForm).length && ObjectUtils.isDifference(this.parentForm, this.initForm)) {
      return await this.notifyUnSaveForm()
    } else {
      return false
    }
  }

  async notifyUnSaveForm() {
    let draftFormUnsaved = this.$t('messages.draft_form_unsaved')
    if (this.isCancel) {
      draftFormUnsaved = this.$t('messages.do_you_revert_before_editing')
    }

    if (
      await new Promise((resolve) =>
        this.$q
          .dialog({
            title: this.$t('messages.confirm'),
            message: draftFormUnsaved,
            cancel: {
              flat: true,
              label: this.$t('messages.no'),
            },
            ok: {
              flat: true,
              label: this.$t('messages.yes'),
            },
            persistent: true,
          })
          .onOk(async () => {
            if (this.isCancel) {
              this.handleResetScenarios()
            }
            resolve(true)
          })
          .onCancel(async () => {
            resolve(false)
          })
      )
    ) {
      return true
    } else {
      return false
    }
  }

  onCancel() {
    this.checkDraftValue()
  }

  handleResetScenarios() {
    if (this.$route.name === 'initial_setting' || this.$route.name === 'push_setting') {
      let campaignId = ''
      if (this.$route.name === 'initial_setting') {
        campaignId = this.$route.params.initial_id as string
      } else {
        campaignId = this.$route.params.push_id as string
      }
      const key = constant.LOCAL_KEYS.SESSION_SCENARIOS + this.appId + '-' + campaignId
      localStore.removeStartsWith(key)
    }
  }

  handleBeforeUnload() {
    console.log('handleBeforeUnload', this.$route.name)
    localStore.removeStartsWith(constant.LOCAL_KEYS.ASSETS_MESSAGES + this.appId)
    localStore.removeStartsWith(constant.LOCAL_KEYS.ASSETS_QAS + this.appId)
    localStore.removeStartsWith(constant.LOCAL_KEYS.ASSETS_GOALS + this.appId)
    localStore.removeStartsWith(constant.LOCAL_KEYS.ASSETS_FORMS + this.appId)
    localStore.removeStartsWith(constant.LOCAL_KEYS.MEDIAS + this.appId)

    localStore.removeStartsWith(constant.LOCAL_KEYS.AUDIENCES + this.appId)
    localStore.removeStartsWith(constant.LOCAL_KEYS.AUDIENCE_USERS + this.appId)

    localStore.removeStartsWith(constant.LOCAL_KEYS.CAMPAIGNS)
    localStore.removeStartsWith(constant.LOCAL_KEYS.CAMPAIGN_TAGURL)
    localStore.removeStartsWith(constant.LOCAL_KEYS.POPUPS + this.appId)
    localStore.removeStartsWith(constant.LOCAL_KEYS.TRAFFIC_SOURCES + this.appId)
    localStore.removeStartsWith(constant.LOCAL_KEYS.CAMPAIGNS_COMPACT + this.appId)

    localStore.removeStartsWith(constant.LOCAL_KEYS.INITIALS + this.appId)
    localStore.removeStartsWith(constant.LOCAL_KEYS.SCENARIO_TEMPLATES + this.appId)
    localStore.removeStartsWith(constant.LOCAL_KEYS.TARGET_SETTINGS + this.appId)
    localStore.removeStartsWith(constant.LOCAL_KEYS.SESSION_SCENARIOS + this.appId)
    localStore.removeStartsWith(constant.LOCAL_KEYS.TOTAL_USERS_REPORT_SCENARIO + this.appId)

    localStore.removeStartsWith(constant.LOCAL_KEYS.PUSHES + this.appId)
    localStore.removeStartsWith(constant.LOCAL_KEYS.DELIVER_LOGS + this.appId)
    localStore.removeStartsWith(constant.LOCAL_KEYS.ANSWER_REPORT + this.appId)

    localStore.removeStartsWith(constant.LOCAL_KEYS.APP_USERS + this.appId)
    localStore.removeStartsWith(constant.LOCAL_KEYS.AUDIENCE_USER_DETAILS + this.appId)

    localStore.removeStartsWith(constant.LOCAL_KEYS.RICH_MENUS + this.appId)

    localStore.removeStartsWith(constant.LOCAL_KEYS.APP_OVER_VIEW_DETAIL + this.appId)
    localStore.removeStartsWith(constant.LOCAL_KEYS.APP_OVER_VIEW + this.appId)

    localStore.removeStartsWith(constant.LOCAL_KEYS.ACTIVITY_LOGS + this.appId)

    localStore.removeStartsWith(constant.LOCAL_KEYS.USERS)
    localStore.removeStartsWith(constant.LOCAL_KEYS.APPS)
    localStore.removeStartsWith(constant.LOCAL_KEYS.PERMISSION_USERS)

    localStore.removeStartsWith(constant.LOCAL_KEYS.AUTO_RESPONSES)

    localStore.removeStartsWith(constant.LOCAL_KEYS.STORIES)

    localStore.removeStartsWith(constant.LOCAL_KEYS.FLEX_MESSAGE_TEMPLATE + this.appId)
  }

  mounted() {
    window.addEventListener('beforeunload', this.handleBeforeUnload)
  }

  beforeUnmount() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
  }
}
